import React from 'react';

import type { PlateElementProps } from 'platejs/react';
import { ParagraphPlugin as BaseParagraphPlugin, PlateElement } from 'platejs/react';

import {
  AA_RESERVED_WIDTH,
  EmptyParagraphAaToggle,
  useEmptyParagraphAaState,
} from '../EmptyParagraphAaToggle';

/**
 * Paragraph element component.
 * Renders as <div> for list items (to avoid <p> inside <li>) or <p> otherwise.
 */
export const ParagraphElement = React.memo(function ParagraphElement(props: PlateElementProps) {
  /**
   * Check if this paragraph is part of a list (has listStyleType)
   * If so, render as a div instead of <p> to avoid <p> inside <li>
   */
  const isListItem = props.element.listStyleType !== undefined;
  /** Non-null only for the blank paragraph the caret is in, in editors that offer it. */
  const aaState = useEmptyParagraphAaState();

  return (
    <PlateElement
      {...props}
      as={isListItem ? 'div' : 'p'}
      style={{
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
        // Anchor the Aa toggle to this line and keep the placeholder clear of it.
        ...(aaState && { paddingRight: AA_RESERVED_WIDTH, position: 'relative' }),
      }}
    >
      {props.children}
      {aaState && <EmptyParagraphAaToggle state={aaState} />}
    </PlateElement>
  );
});

/**
 * Configured ParagraphPlugin with custom element component.
 */
export const ParagraphPlugin = BaseParagraphPlugin.withComponent(ParagraphElement);
